<div *ngFor="let budget of budgetCollection" class="budgetStyle">
    <div (click)="selectStateToFilter(budget)" [ngClass]="budget.selected?'selected':''" class="alarmBudget pointer">
        <p class="valueStyle">{{budget.value}}</p>
        <p class="{{budget.name| translate}}">{{budget.name | translate}}</p>
    </div>
</div>